/**
 * Default Home Tiles
 * Core app tiles that are registered by default on the iOS-style homescreen
 */

import { registerHomeTile } from './homescreen';

/**
 * Register default core app tiles
 * Call this during app initialization
 */
export function registerDefaultTiles() {
  // Weather - Beautiful weather forecast (primary position)
  registerHomeTile({
    id: 'weather',
    label: 'Weather',
    icon: '🌤️',
    route: '/weather',
    section: 'main',
    order: 0,
  });

  // Chat - Real-time messaging
  registerHomeTile({
    id: 'chat',
    label: 'Chat',
    icon: '💬',
    route: '/chat',
    section: 'main',
    order: 1,
  });

  // Store - Plugin marketplace
  registerHomeTile({
    id: 'store',
    label: 'Store',
    icon: '🛒',
    route: '/store',
    section: 'main',
    order: 2,
  });

  // Settings - App configuration
  registerHomeTile({
    id: 'settings',
    label: 'Settings',
    icon: '⚙️',
    route: '/settings',
    section: 'main',
    order: 3,
  });

  // Credits - Wallet and credits
  registerHomeTile({
    id: 'credits',
    label: 'Credits',
    icon: '💰',
    route: '/credits',
    section: 'main',
    order: 4,
  });

  // Dock apps (always visible at bottom)
  // App launcher
  registerHomeTile({
    id: 'shell',
    label: 'Apps',
    icon: '📱',
    route: '/shell',
    section: 'dock',
    order: 0,
  });
}

// Export individual tile registration functions for dynamic loading
export function registerWeatherTile() {
  return registerHomeTile({
    id: 'weather',
    label: 'Weather',
    icon: '🌤️',
    route: '/weather',
    section: 'main',
    order: 0,
  });
}

export function registerChatTile() {
  return registerHomeTile({
    id: 'chat',
    label: 'Chat',
    icon: '💬',
    route: '/chat',
    section: 'main',
    order: 1,
  });
}

export function registerStoreTile() {
  return registerHomeTile({
    id: 'store',
    label: 'Store',
    icon: '🛒',
    route: '/store',
    section: 'main',
    order: 2,
  });
}

export function registerSettingsTile() {
  return registerHomeTile({
    id: 'settings',
    label: 'Settings',
    icon: '⚙️',
    route: '/settings',
    section: 'main',
    order: 3,
  });
}

export function registerCreditsTile() {
  return registerHomeTile({
    id: 'credits',
    label: 'Credits',
    icon: '💰',
    route: '/credits',
    section: 'main',
    order: 4,
  });
}
